import { Chip, Stack } from "@bvhi/ui-base";

interface Props {
  channels?: string[];
}

export const AudiologistsPrimaryChannelsCell = ({ channels }: Props) => {
  if (!channels || channels.length === 0) {
    return (
      <Stack spacing={1} useFlexGap>
        <Chip color="error" label="Inaktiv" size="small" />
      </Stack>
    );
  }

  return (
    <Stack spacing={1} useFlexGap>
      {channels.map((channel, index) => (
        <Chip key={index} label={channel} size="small" />
      ))}
    </Stack>
  );
};
